import FetchBase from '../Api/FetchBase'
import { observable, action, computed } from 'mobx'
import { API_ENDPOINTS } from '../Utils/constants'
import { ThemeProvider } from 'styled-components'

export default class RolesStore extends FetchBase {
  @observable ordering = undefined
  @observable orderingBy = undefined

  @observable mediacentricRolesLoader = false
  @observable mediacentricRoles = []
  @observable getsitelead = []

  @observable customerRolesLoader = false
  @observable customerRoles = []

  @observable orderingProjectRole = undefined
  @observable orderingByProjectRole = undefined
  @observable projectRoleSearchText = undefined
  @observable projectRolesLoader = false
  @observable projectRolesDropdownList = []
  @observable projectRolesList = {}

  @observable rolesPermissionsLoader = false
  @observable rolesPermissions = []

  @observable addRoleLoader = false
  @observable updateRoleLoader = false
  @observable permissionChangeLoader = false
  @observable OnSiteSwitch = false

  @observable roleTypesToAssignLoader = false
  @observable roleTypesToAssign = []

  @observable mediacentricRoleSearchText = ''
  @observable customerRoleSearchText = ''

  @observable roleModalPermissionsList = []
  @observable roleModalPermissionsListLoader = false

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setMediacentricRoleSearchText = (value = '') => {
    this.mediacentricRoleSearchText = value
  }

  @action.bound
  setCustomerRoleSearchText = (value = '') => {
    this.customerRoleSearchText = value
  }

  @computed
  get mediacentricRolesGet() {
    if (this.mediacentricRoleSearchText) {
      let value = (this.mediacentricRoleSearchText || '').toLowerCase()
      return (this.mediacentricRoles || []).filter((role) => {
        let name = (role?.name || '').toLowerCase()
        return name.includes(value)
      })
    }
    return this.mediacentricRoles
  }

  @computed
  get customerRolesGet() {
    if (this.customerRoleSearchText) {
      let value = (this.customerRoleSearchText || '').toLowerCase()
      return (this.customerRoles || []).filter((role) => {
        let name = (role?.name || '').toLowerCase()
        return name.includes(value)
      })
    }
    return this.customerRoles
  }

  getFiltersForMediacentricRoles = () => {
    let temp = {}
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    return temp
  }

  @action.bound
  getAllMediacentricRoles = async (signal, listDropdown = false) => {
    try {
      let filters = this.getFiltersForMediacentricRoles()

      this.mediacentricRolesLoader = true
      let response = await this.get(
        listDropdown
          ? API_ENDPOINTS.MEDIACENTRIC_USERS_ROLES
          : API_ENDPOINTS.GET_MEDIACENTRIC_ROLES,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.mediacentricRoles = response.data
        return [true, response.data]
      }
      this.mediacentricRoles = []
      return [false, undefined]
    } catch (err) {
      this.mediacentricRoles = []
      return [false, undefined]
    } finally {
      this.mediacentricRolesLoader = false
    }
  }

  @action.bound
  getOnsiteLead = async (signal) => {
    try {
      this.mediacentricRolesLoader = true
      let response = await this.get(API_ENDPOINTS.GET_ONSITE_LEAD, {}, signal)
      if (response.status) {
        this.OnSiteSwitch = response?.data?.permission
        return [true, response.data]
      } else {
        this.getsitelead = []
        return [false, undefined]
      }
    } catch (err) {
      this.getsitelead = []
      return [false, undefined]
    } finally {
      this.mediacentricRolesLoader = false
    }
  }
  getFiltersForMediacentricRoles = () => {
    let temp = {}
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    return temp
  }

  @action.bound
  getAllCustomersRoles = async (signal, listDropdown = false) => {
    try {
      let filters = this.getFiltersForMediacentricRoles()
      this.customerRolesLoader = true
      let response = await this.get(
        listDropdown
          ? API_ENDPOINTS.CUSTOMER_ROLES_LIST
          : API_ENDPOINTS.GET_CUSTOMER_ROLES,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.customerRoles = response.data
        return [true, response.data]
      }
      this.customerRoles = []
      return [false, undefined]
    } catch (err) {
      this.customerRoles = []
      return [false, undefined]
    } finally {
      this.customerRolesLoader = false
    }
  }

  @action.bound
  getDropdownProjectRole = async (signal) => {
    try {
      this.projectRolesDropdownListLoader = true
      let response = await this.post(
        API_ENDPOINTS.GET_DROPDOWN_PROJECT_ROLE,
        {},
        signal
      )
      if (response.status) {
        this.projectRolesDropdownList = response.data.projectRoles
        return [true, response.data.projectRoles]
      }
      this.projectRolesDropdownList = []
      return [false, undefined]
    } catch (err) {
      this.projectRolesDropdownList = []
      return [false, undefined]
    } finally {
      this.projectRolesDropdownListLoader = false
    }
  }

  @action.bound
  setOrderingProjectRole = (value = undefined) => {
    this.orderingProjectRole = value
  }

  @action.bound
  setOrderingByProjectRole = (value = undefined) => {
    if (value === 'title') {
      value = 'name'
    }
    this.orderingByProjectRole = value
  }

  @action.bound
  setProjectRoleSearchText = (value = '') => {
    this.projectRoleSearchText = value
  }

  @computed
  get projectRolesGet() {
    if (this.projectRoleSearchText) {
      let value = (this.projectRoleSearchText || '').toLowerCase()
      return (this.projectRolesList.projectRoles || []).filter((role) => {
        let name = (role?.name || '').toLowerCase()
        return name.includes(value)
      })
    }
    return this.projectRolesList.projectRoles
  }

  getFiltersForProjectRoles = () => {
    let temp = {}
    if (this.orderingProjectRole) {
      temp['ordering'] = this.orderingProjectRole
      temp['orderBy'] = this.orderingByProjectRole
    }
    return temp
  }

  @action.bound
  getAllProjectRoles = async (signal) => {
    try {
      this.projectRolesLoader = true
      let filters = this.getFiltersForProjectRoles()
      let response = await this.post(
        API_ENDPOINTS.GET_PROJECT_ROLES,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.projectRolesList = response.data
        return [true, response.data]
      }
      this.projectRolesList = {}
      return [false, undefined]
    } catch (err) {
      this.projectRolesList = {}
      return [false, undefined]
    } finally {
      this.projectRolesLoader = false
    }
  }

  @action.bound
  getPermissionsBasedOnRole = async (roleId, signal) => {
    try {
      this.rolesPermissionsLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_ROLE_BASED_PERMISSIONS,
        {
          roleId,
        },
        signal
      )
      if (response.status) {
        this.rolesPermissions = response.data
        return [true, response.data]
      }
      this.rolesPermissions = []
      return [false, undefined]
    } catch (err) {
      this.rolesPermissions = []
      return [false, undefined]
    } finally {
      this.rolesPermissionsLoader = false
    }
  }

  @action.bound
  deleteRoleLocallyCustomer = (id) => {
    this.customerRoles = (this.customerRoles || []).filter(
      (role) => role.id !== id
    )
  }

  @action.bound
  deleteRoleLocallyMediacentric = (id) => {
    this.mediacentricRoles = (this.mediacentricRoles || []).filter(
      (role) => role.id !== id
    )
  }

  @action.bound
  deleteRole = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ROLE, {
        id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addRoleLocallyCustomer = (values) => {
    this.customerRoles = [...this.customerRoles, values]
  }

  @action.bound
  addRoleLocallyMediacentric = (values) => {
    this.mediacentricRoles = [...this.mediacentricRoles, values]
  }

  @action.bound
  addRole = async (values) => {
    try {
      this.addRoleLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_ROLE_WITH_PERMISSIONS, {
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addRoleLoader = false
    }
  }

  @action.bound
  updateRoleLocallyCustomer = (values) => {
    this.customerRoles = (this.customerRoles || []).map((role) => {
      if (role.id === values.id) {
        return values
      } else {
        return role
      }
    })
  }

  @action.bound
  updateRoleLocallyMediacentric = (values) => {
    this.mediacentricRoles = (this.mediacentricRoles || []).map((role) => {
      if (role.id === values.id) {
        return values
      } else {
        return role
      }
    })
  }

  @action.bound
  updateRole = async (id, values) => {
    try {
      this.updateRoleLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_ROLE, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateRoleLoader = false
    }
  }

  @action.bound
  addProjectRoleLocally = (values) => {
    this.projectRolesList.projectRoles = [
      ...this.projectRolesList.projectRoles,
      values,
    ]
  }

  @action.bound
  addProjectRole = async (values) => {
    try {
      this.addRoleLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_PROJECT_ROLE, {
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addRoleLoader = false
    }
  }

  @action.bound
  updateProjectRoleLocally = (values) => {
    this.projectRolesList.projectRoles = (
      this.projectRolesList.projectRoles || []
    ).map((role) => {
      if (role.id === values.id) {
        return values
      } else {
        return role
      }
    })
  }

  @action.bound
  updateProjectRole = async (id, values) => {
    try {
      this.updateRoleLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_PROJECT_ROLE, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateRoleLoader = false
    }
  }

  @action.bound
  deleteProjectRoleLocally = (id) => {
    this.projectRolesList.projectRoles = (
      this.projectRolesList.projectRoles || []
    ).filter((role) => role.id !== id)
  }

  @action.bound
  deleteProjectRole = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_PROJECT_ROLE, {
        id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  changePermission = async (values) => {
    try {
      this.permissionChangeLoader = true
      let response = await this.post(API_ENDPOINTS.ROLE_CHANGE_BY_OP, values)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.permissionChangeLoader = false
    }
  }

  @action.bound
  updateOnsiteLead = async (permission) => {
    try {
      this.permissionChangeLoader = true
      let response = await this.post(
        API_ENDPOINTS.UPDATE_ONSITE_LEAD,
        permission
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.permissionChangeLoader = false
    }
  }

  @action.bound
  getRoleTypesToAssign = async () => {
    try {
      this.roleTypesToAssignLoader = true
      let response = await new Promise((res, rej) => {
        res({
          status: true,
          data: [
            {
              id: 0,
              name: 'Organization Role',
            },
            {
              id: 1,
              name: 'Customer Role',
            },
          ],
        })
      })
      if (response.status) {
        this.roleTypesToAssign = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.roleTypesToAssignLoader = false
    }
  }

  @action.bound
  getRoleListForModal = async (isCustomerOperation = false, options = {}) => {
    try {
      this.roleModalPermissionsListLoader = true
      let response = await this.post(API_ENDPOINTS.ROLE_LIST_OPERATIONS, {
        isCustomerOperation: Boolean(isCustomerOperation),
        ...options,
      })
      this.roleModalPermissionsList = response.data || []
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.roleModalPermissionsListLoader = false
    }
  }

  @action.bound
  resetRoleList = () => {
    this.roleModalPermissionsListLoader = false
    this.roleModalPermissionsList = []
  }

  @action.bound
  resetStore = () => {
    this.ordering = undefined
    this.orderingBy = undefined
    this.mediacentricRolesLoader = false
    this.mediacentricRoles = []
    this.getsitelead = []
    this.customerRolesLoader = false
    this.customerRoles = []
    this.orderingProjectRole = undefined
    this.orderingByProjectRole = undefined
    this.projectRoleSearchText = undefined
    this.projectRolesDropdownList = []
    this.projectRolesLoader = false
    this.projectRolesList = {}
    this.rolesPermissionsLoader = false
    this.rolesPermissions = []
    this.addRoleLoader = false
    this.updateRoleLoader = false
    this.permissionChangeLoader = false
    this.roleTypesToAssignLoader = false
    this.roleTypesToAssign = []
    this.mediacentricRoleSearchText = ''
    this.customerRoleSearchText = ''
    this.roleModalPermissionsList = []
    this.roleModalPermissionsListLoader = false
    this.OnSiteSwitch = false
  }
}
